export default __webpack_public_path__ + "static/media/GMAFIABAT.167566d5.png";